

import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* 법적 고지 */}
      <div className="bg-gray-800 py-4">
        <div className="container mx-auto px-4">
          <div className="flex items-start">
            <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1 flex-shrink-0">
              <i className="ri-information-line text-gray-400"></i>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              본 페이지의 수치와 시나리오는 이해를 돕기 위한 예시입니다. 실제 사업 범위, 인허가, 분양가, 주변 시세, 금융환경 등에 따라 달라질 수 있으며, 
              확정 정보는 주관 기관의 공식 문서를 통해 공지됩니다.
            </p>
          </div>
        </div>
      </div>
      
      {/* 메인 푸터 */}
      <div className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* 좌측 - 저작권 */}
            <div>
              <div className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                대청마을 북측 모아타운 사업성 평가 위원회
              </div>
              <p className="text-gray-400 text-sm">
                Copyright © 대청마을 북측구역 사업성 평가 연구회<br />
                All rights reserved.
              </p>
            </div>
            
            {/* 중앙 - 링크 */}
            <div className="flex flex-col md:items-center">
              <h4 className="font-semibold mb-4">바로가기</h4>
              <div className="space-y-2">
                <button className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  개인정보 처리방침
                </button>
                <button className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  이용약관
                </button>
                <button className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  공지사항
                </button>
              </div>
            </div>
            
            {/* 우측 - 주소 및 로고 */}
            <div className="md:text-right">
              <h4 className="font-semibold mb-4">위치</h4>
              <p className="text-gray-400 text-sm mb-4">
                서울 강남구 일원동<br />
                대청마을 북측 구역
              </p>
              <div className="text-xs text-gray-500">
                <div className="mb-2" style={{ fontFamily: '"Pacifico", serif' }}>logo</div>
              </div>
            </div>
          </div>
          
          {/* 하단 링크 */}
          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

